const Session = require('./session');

var apiBaseUrl = getApiBaseUrl();

function getFullUrl(methodUrl) {
    return apiBaseUrl + methodUrl;
}

function getFetchConfig(method, data, signal) {
    var body = null;
    var headers = {};

    if (data instanceof FormData) {
        body = data;
    } else {
        if (data) {
            body = JSON.stringify(data);
        }
        headers['Content-Type'] = 'application/json; charset=utf-8';
    }

    return {
        signal,
        body: body,
        method: method,
        headers: headers,
        credentials: 'include',
        mode: 'cors'
    };
}

function apiGetInner(methodUrl) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('GET'))
        .then(catch401)
        .then(resolveJson);
}

function apiPostInner(methodUrl, data = {}, signal) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('POST', data, signal))
        .then(catch401)
        .then(resolveJson);
}

function apiDownloadInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('POST', data))
        .then(catch401)
        .then(catch400)
        .then(d => {
                return d.blob().then(res => (
                    {
                        data: res,
                        headers: {"content-disposition": d.headers.get('Content-Disposition')}
                    }
                ))
            }
        );
}

function apiPutInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('PUT', data))
        .then(catch401)
        .then(resolveJson);
}

function apiDeleteInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('DELETE', data))
        .then(catch401)
        .then(resolveJson);
}

function catch401(response) {
    if (response.status === 401) {
        stopApiSession();
        return Promise.reject("Unauthorized");
    }
    if (response.status > 401) {
        return Promise.reject(response);
    }
    return Promise.resolve(response);
}

function catch400(response) {
    if (response.status === 400) {
        return response.text()
            .then(text => {
                return Promise.reject(convertJson(text));
            });
    } else {
        return Promise.resolve(response);
    }
}

function convertJson(text) {
    try {
        return JSON.parse(text);
    } catch (err) {
        return text;
    }
}

function resolveJson(response) {
    return response.text()
        .then(text => {
            let result = convertJson(text);
            if (!response.ok) {
                // Если ответ пустой или не JSON, создаем объект ошибки с информацией о статусе
                if (!result || (typeof result === 'string' && result.trim() === '')) {
                    let statusText = response.statusText || 'Unknown error';
                    if (response.status === 403) {
                        result = { Error: 'Недостаточно прав для выполнения операции' };
                    } else if (response.status === 404) {
                        result = { Error: 'Ресурс не найден' };
                    } else {
                        result = { Error: `Ошибка ${response.status}: ${statusText}` };
                    }
                }
                return Promise.reject(result);
            }
            return result;
        });
}

function validateToken() {
    if (Session.isAnonymousAllowed()) {
        return Promise.resolve(true);
    } else {
        return apiGetInner('auth/check')
            .then(() => {
                return Promise.resolve(true);
            });
    }
}

function stopApiSession(needLogout) {
    Session.stopSession(needLogout);
}

function apiGet(methodUrl) {
    return apiGetInner(methodUrl);
}

function apiPost(methodUrl, data = {}, signal) {
    return apiPostInner(methodUrl, data, signal);
}

function apiDownload(methodUrl, data = {}) {
    return apiDownloadInner(methodUrl, data);
}

function apiPut(methodUrl, data = {}) {
    return apiPutInner(methodUrl, data);
}

function apiDelete(methodUrl, data = {}) {
    return apiDeleteInner(methodUrl, data);
}

module.exports = {
    validateToken: validateToken,
    stopApiSession: stopApiSession,
    apiGet: apiGet,
    apiPost: apiPost,
    apiPut: apiPut,
    apiDelete: apiDelete,
    apiDownload
};


// WEBPACK FOOTER //
// ./App/services/apiClient.js